import React from 'react';

import { fmDate, fmDateTime } from '../common/formatter.jsx';
import { LabelGrid } from '../common/components.jsx';
import { getMappingFromStatus } from "../common/osWidgetLib.js";

//----------------------------------------------------------------------
//   hDates -- show header level order informations
//
//----------------------------------------------------------------------
export class Dates extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    var order = this.props.order;
    var caller = this.props.caller;

    if (typeof caller === 'undefined') {
      caller = 'osv';
    }
 
    var complShipDate = '';
    var complDeliveredDate = '';
    if ( order.customer_ship_date != "") {
        complShipDate    = fmDateTime(order.customer_ship_date);
    }
    if ( order.pod_date != "") {
        complDeliveredDate    = fmDateTime(order.pod_date);
    }

    var endcustDelvDateLbl   = null;
    var endcustDelvDate      = null;

    var endcustPlDelvDateLbl = null;
    var endcustPlDelvDate    = null;
    var ois_dates = [];

    if ( order.endcust_planned_delivery_date != "") {
        endcustPlDelvDateLbl = DD('endcust_planned_delivery_date', caller);
        endcustPlDelvDate    = fmDate(order.endcust_planned_delivery_date);
    }

    if ( order.endcust_delivery_date != "") {
        endcustDelvDateLbl = DD('endcust_delivery_date', caller);
        endcustDelvDate    = fmDate(order.endcust_delivery_date);
    }

    if ( order.order_overall_status == "Submitted" ) {
      ois_dates = [ DD('ois_latest_response', caller), fmDateTime(order.ois_latest_response), DD('ois_latest_reprocess', caller), fmDateTime(order.ois_latest_reprocess),DD('ois_latest_cancel'), fmDateTime(order.ois_latest_cancel),]
    }

    if ((typeof order.fraud_approved_date !== 'undefined' && order.fraud_approved_date != '') 
      && (typeof order.payment_receive_date !== 'undefined' && order.payment_receive_date != '')) {
      var labelGridDataDates = [
        [
          DD('quote_date', caller), fmDateTime(order.quote_date),
          DD('credit_approval_date', caller), fmDateTime(order.credit_approval_date),
          DD('compl_landed_date', caller), fmDateTime(order.compl_landed_date)
        ],
        [
          DD('web_order_creation_dt', caller), fmDateTime(order.web_order_creation_dt),
          DD('order_load_date', caller), fmDateTime(order.order_load_date),
          DD('CompleteCustomerShipDate', caller), complShipDate,
        ],
        [
          DD('purch_order_date', caller), fmDateTime(order.purch_order_date),
          DD('clean_order_date', caller), fmDateTime(order.clean_order_date),
          DD('CompleteDeliveryDate', caller), complDeliveredDate,
        ],
        [
          DD('hp_receive_date', caller), fmDateTime(order.hp_receive_date),
          DD('clean_hdr_date', caller), fmDateTime(order.clean_hdr_date),
          DD('customer_req_date', caller), fmDateTime(order.customer_req_date),
        ],
        [
          endcustPlDelvDateLbl, endcustPlDelvDate,
          endcustDelvDateLbl,   endcustDelvDate,
          DD('order_close_date', caller), fmDateTime(order.order_close_date),
        ],
        [
          "", "",
          DD('fraud_approved_date', caller), fmDateTime(order.fraud_approved_date),
          "", "",
        ],
        [
          "", "",
          DD('payment_receive_date', caller), fmDateTime(order.payment_receive_date),
          "", "",
        ]
      ]
    } else {

      var labelGridDataDates = [
        [
          DD('quote_date', caller), fmDateTime(order.quote_date),
          DD('credit_approval_date', caller), fmDateTime(order.credit_approval_date),
          DD('compl_landed_date', caller), fmDateTime(order.compl_landed_date)
        ],
        [
          DD('web_order_creation_dt', caller), fmDateTime(order.web_order_creation_dt),
          DD('order_load_date', caller), fmDateTime(order.order_load_date),
          DD('CompleteCustomerShipDate', caller), complShipDate,
        ],
        [
          DD('purch_order_date', caller), fmDateTime(order.purch_order_date),
          DD('clean_order_date', caller), fmDateTime(order.clean_order_date),
          DD('CompleteDeliveryDate', caller), complDeliveredDate,
        ],
        [
          DD('hp_receive_date', caller), fmDateTime(order.hp_receive_date),
          DD('clean_hdr_date', caller), fmDateTime(order.clean_hdr_date),
          DD('customer_req_date', caller), fmDateTime(order.customer_req_date),
        ],
        ois_dates,
        [
          endcustPlDelvDateLbl, endcustPlDelvDate,
          endcustDelvDateLbl,   endcustDelvDate,
          DD('order_close_date', caller), fmDateTime(order.order_close_date),
        ]
      ]
    }


    return (
      <div id="hMoreInfo">
        <LabelGrid data={labelGridDataDates} />
      </div>
    )
  }

};
